import nodeApi from '../utils/nodeApiClient';

const servicesApi = {
  list: (params) => nodeApi.get('/services', { params }),
  create: (data) => nodeApi.post('/services', data),
  update: (id, data) => nodeApi.put(`/services/${id}`, data),
  remove: (id) => nodeApi.delete(`/services/${id}`),
  toggleStatus: (id) => nodeApi.patch(`/services/${id}/status`)
};

export default servicesApi;
